import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';

const pageTitles = {
  ar: 'مروه هوشر | محامية في طرابلس، لبنان | Marwa Hawshar',
  en: 'Marwa Hawshar | Lawyer in Tripoli, Lebanon | محامية طرابلس',
  fr: 'Marwa Hawshar | Avocate à Tripoli, Liban | محامية طرابلس',
};

const pageDescriptions = {
  ar: 'مروه هوشر (Marwa Hawshar) — محامية بالاستئناف في طرابلس، لبنان. قضايا مدنية وجزائية وشرعية وعقارية وتجارية، وإرث وميراث، وخدمات للمغتربين. منتسبة الى نقابة محامي طرابلس. +961 3 313 264',
  en: 'Marwa Hawshar, appellate-level attorney in Tripoli, Lebanon. Civil, criminal, Sharia, real estate, and commercial law, inheritance, and services for Lebanese expatriates. Member of the Tripoli Bar Association. +961 3 313 264',
  fr: "Marwa Hawshar, avocate en appel à Tripoli, Liban. Droit civil, pénal, du statut personnel, immobilier et commercial, succession, et services pour les expatriés libanais. Membre du barreau de Tripoli. +961 3 313 264",
};

function applyLanguage(lng) {
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  document.title = pageTitles[lng] ?? pageTitles.ar;

  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) metaDesc.setAttribute('content', pageDescriptions[lng] ?? pageDescriptions.ar);

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', pageTitles[lng] ?? pageTitles.ar);

  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', pageDescriptions[lng] ?? pageDescriptions.ar);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    fr: { translation: fr },
  },
  lng: 'ar',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', applyLanguage);

// Apply immediately for the default language
applyLanguage('ar');

export default i18n;
